/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_ConfirmInputs */

const vi_order_action_confirm = /** @type {(inputs: Order_Action_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận`)
};

/**

* @param {Order_Action_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_confirm = /** @type {((inputs?: Order_Action_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_confirm(inputs)
});